import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

type ButtonLoadingProps = {
  loading: boolean;
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  propClassName?: string;
};

export function ButtonLoading({
  loading,
  children,
  onClick,
  disabled,
  propClassName,
}: ButtonLoadingProps) {
  return (
    <Button
      onClick={onClick}
      disabled={loading || disabled}
      className={
        propClassName +
        " hover:bg-gray-600 hover:ring-2 hover:ring-primary hover:scale-105 transition duration-150"
      }
    >
      {loading ? (
        <>
          <Loader2 className={"mr-2 h-4 w-4 animate-spin"} />
          Please wait
        </>
      ) : (
        children
      )}
    </Button>
  );
}
